import styled from 'styled-components';
import { TabList as RTTabList } from 'react-tabs';
import { compose, margin, padding } from 'styled-system';
import { MarginProps, PaddingProps } from '../../../theme/styledProps';

interface TabListProps extends PaddingProps, MarginProps {}

export const TabList = styled(RTTabList)<TabListProps>(
  ({ theme }) => ({
    margin: 0,
    padding: 0,
    borderBottom: `1px solid ${theme.colors.neutral['200']}`,
  }),

  compose(margin, padding),
);
